import { useParams } from 'react-router-dom';

const PDFViewer = () => {
    const { pdfFile } = useParams();
    //console.log("PDF=" + pdfFile);

    return (
        <div className='page-content'>
            <iframe title='pdfviewer' src={pdfFile + ".pdf"} className="content-in-iframe" />
        </div>
    );
};

export default PDFViewer;